module.exports = __webpack_public_path__ + "static/media/blueTheme-girl.e3a73f52.svg";